exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2NhxCDAabrLFg1bP1Fmzms{-webkit-box-align:stretch;-webkit-align-items:stretch;-moz-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;border:.07143rem solid #0087e6;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:2.5rem;overflow:hidden}._32dRsdSVTWmuyVy7wK6MlH{background:#f3f5f7;border:0;color:#0087e6;cursor:pointer;font-size:1rem;min-width:3.5rem;padding:0 .71429rem}._32dRsdSVTWmuyVy7wK6MlH:focus{outline:none}._32dRsdSVTWmuyVy7wK6MlH._1lkh-y5c_J_1DE83RzcuvO{background:#0087e6;color:#fff}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"LanguageSwitcher": "_2NhxCDAabrLFg1bP1Fmzms",
	"LanguageSwitcher_option": "_32dRsdSVTWmuyVy7wK6MlH",
	"_selected": "_1lkh-y5c_J_1DE83RzcuvO"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/LanguageSwitcher/style.postcss
// module id = 1568
// module chunks = 0